/* eslint-disable max-len */
import { promotionInfo } from "./promotion-info";
import { awards } from "./awards";
import { resume } from "./resume";
import { sideTab } from "./side-tab";

export const promotions = {
	title: "Promociones",
	filter: {
		label: "Filtro",
		all: "Todas",
		active: "Activas",
		inactive: "Inactivas",
	},
	search: "Busque por nombre de la promoción",
	empty: "La búsqueda no encontró resultados",
	withoutPromotions: "No existen promociones registradas",
	create: "Crear promoción",
	createPromotion: {
		promotionInfo,
		goals: {
			title: "Metas",
			description:
				"Las metas son parámetros que van a determinar lo que su cliente necesita hacer para ganar la promoción.",
		},
		awards,
		usageConditions: {
			title: "Condiciones de uso",
			description:
				"En esta etapa usted puede definir parámetros de uso de la promoción. Cuando el cliente gana la promoción, solo puede utilizarla si sigue estas condiciones de uso.",
			warning: `- Las condiciones de uso para 'Compre y Gane' también son usadas para ganar la promoción. \n - Expiración post-ganancia no se aplica para el 'Compre y Gane'.`,
		},
		resume,
	},
	card: {
		subtitle: "Descuento de {{discount}}",
		withoutDiscount: "Sin Descuento",
		expiresAt: "Expira en {{date}} Día(s)",
		noExpirationDate: "Sin plazo de expiración",
		active: "Activa",
		inactive: "Inactiva",
	},
	sideTab,
	selected: {
		feature: "La funcionalidad 'Compre y Gane' debe estar activa",
		title: "Nombre de la promoción",
		active: "Activa",
		inactive: "Inactiva",
		clientList: "Lista de clientes",
		clientListModal: {
			title: "Lista de clientes {{promotionName}}",
			addClient: {
				label: "Agregar clientes a la lista",
				placeholder: "Ingrese CPF del cliente",
				placeholderForeign: "Ingrese el teléfono del cliente",
				addClient: "Agregar cliente",
				foreign: "Extranjero",
			},
			search: "Busque por nombre o CPF",
			searchForeign: "Busque por nombre o teléfono",
			remove: "Eliminar clientes seleccionados",
			columns: {
				name: "Nombre",
				cpf: "CPF",
				cpfForeign: "Documento",
				phone: "Teléfono",
			},
			error: "No fue posible agregar los clientes abajo:",
		},
		copy: "Crear copia",
		discountValue: {
			title: "Descuento de {{discount}}",
			unavailable: "No disponible",
		},
		maxUses: {
			title: "{{uses}} usos por persona",
			withoutLimit: "Sin límite de uso individual",
		},
		expirationTime: {
			title: "Expira en: {{date}} Días",
			noExpires: "Sin plazo de expiración",
		},
		productsList: {
			title: "PRODUCTOS EN PROMOCIÓN",
			all: "Todos los productos",
			unavailable: "Producto no disponible",
			seeMore: "ver más",
			seeLess: "ver menos",
		},
		erasePromotion: {
			title: "Eliminar promoción",
			confimation: "¿Está seguro que quiere eliminar la promoción?",
		},
	},
};
